export const environment = {
  production: true,
  api: 'https://api-maison-bleu-lin.agence-11h10.fr',
  url: 'https://maisonbleulin.com/',
  s3 : 'https://s3.eu-west-3.amazonaws.com/maison-bleu-lin/',
  siteKey: "6LcMkkQUAAAAAOyOmJN8Sq_miu73PWzm23P2ZiIf"
};
